<template>
  <div>
    <v-form ref="form" v-model="valid" action="javascript:void(0);" >
      <v-text-field outlined  v-model="email" v-if="!verificationState" :rules="$root.auth.emailRules" required label="E-Mail" />
      <v-text-field outlined  v-model="password" v-if="!verificationState" :rules="$root.auth.passwordRules" required label="Password" type="password" />
      <v-text-field outlined  v-model="code" v-else :rules="$root.auth.codeRules" required label="Confirmation Code" />
      <v-btn v-if="!verificationState" block text tile class="mb-2" :to="{name: 'ForgotPassword'}">Forgot your password?</v-btn>
      <v-btn block depressed rounded light large :loading="$root.auth.working" type="submit" @click="validate">{{verificationState ? 'Confirm your Email' : 'Sign In'}}</v-btn>
    </v-form>
  </div>
</template>

<script>
import trim from 'lodash/trim'
export default {
  name: 'LoginForm',
  props: {
    precompiledEmail: {
      type: String,
      required: false
    },
    precompiledPassword: {
      type: String,
      required: false
    },
    verificationState: {
      type: Boolean,
      required: true
    }
  },
  data () {
    return {
      valid: true,
      email: this.$root.loggedUser ? this.$root.auth.loggedUser.username : null || this.precompiledEmail,
      password: this.precompiledPassword,
      code: null
    }
  },
  mounted () {
    if (this.precompiledEmail && this.precompiledPassword) {
      this.validate()
    }
  },
  watch: {
    precompiledEmail (value) {
      this.email = value
    },
    precompiledPassword (value) {
      this.password = value
    }
  },
  methods: {
    async validate () {
      if (this.$refs.form.validate()) {
        if (!this.verificationState) {
          await this.signin()
        } else {
          await this.verify()
        }
      }
    },
    async verify () {
      try {
        await this.$root.auth.confirmSignup(trim(this.email).toLowerCase(), this.code)
      } catch (e) {
        this.$root.auth.authError = e.code
      }
      await this.signin()
    },
    async signin () {
      try {
        await this.$root.auth.signIn(trim(this.email).toLowerCase(), this.password)
        // const data = await this.$root.auth.signIn(this.email, this.password)
        // console.log('signin success', data)
        // this.$router.replace({ name: 'UserArea' })
      } catch (e) {
        if (e.code === 'UserNotConfirmedException') {
          this.$emit('update:verificationState', true)
          // this.verificationState = true
        }
      }
    }
  }
}
</script>
